export default __webpack_public_path__ + "static/media/ai.f3455f3f.jpg";